import colors from '../options/colors'
import patterns from '../utils/patterns'

const DaysBgPattern = (Days) => {
  if (
    !Days.mainXAxis ||
    !Days.mainSeries ||
    !Days.volumeSeries ||
    !Days.sma20Series
  ) {
    return
  }

  Days.removePatternBg()

  const sellingIndex = [],
    buyingIndex = []

  Days.mainSeries.yData.forEach((y, x) => {
    if (x < 59) {
      return
    }

    const currentVolume = Days.volumeSeries.yData[x]
    const last60VolumesAverage =
      Days.volumeSeries.yData
        .slice(x + 1 - 60, x + 1)
        .reduce((a, b) => a + b, 0) / 60

    if (y[3] - y[0] >= 0) {
      const sma20 = Days.sma20Series.yData[Days.sma20Series.xData.indexOf(x)]
      const lastDayTradePrice = Days.mainSeries.yData[x - 1][3]
      const candleBodyRatio = (y[3] - y[0]) / Math.max(y[1] - y[2], 1)

      const isBuying =
        last60VolumesAverage * 1.5 <= currentVolume &&
        sma20 <= y[3] &&
        lastDayTradePrice * 1.03 <= y[3] &&
        candleBodyRatio >= 0.5

      isBuying && buyingIndex.push(x)
    } else {
      const last21Candles = Days.mainSeries.yData.slice(x + 1 - 21, x + 1)
      const lastDayHighPrice = Days.mainSeries.yData[x - 1][1]

      const isSelling =
        last60VolumesAverage * 1.8 <= currentVolume &&
        lastDayHighPrice <= y[1] &&
        patterns.isRankedByFluctuatingGapInLast20Days(5, last21Candles)

      isSelling && sellingIndex.push(x)
    }
  })

  const plotBands = patterns.getPlotBands(
    buyingIndex,
    sellingIndex,
    colors.pattern.buying,
    colors.pattern.selling
  )

  plotBands.forEach((plotBand) => {
    Days.mainXAxis.addPlotBand(plotBand, false)
    Days.patternBgIds.push(plotBand.id)
  })
}

export default DaysBgPattern
